import { MessageDescriptor } from 'react-intl';
import { HubModuleType } from '../../../../../../../../api/event-hubs.dao';
import {
    EVENTS_MODULE_TYPE_DESCRIPTION_TEXT,
    EVENTS_MODULE_TYPE_NAME_TEXT,
    MY_EVENTS_MODULE_TYPE_DESCRIPTION_TEXT,
    MY_EVENTS_MODULE_TYPE_NAME_TEXT,
    RICH_TEXT_MODULE_TYPE_DESCRIPTION_TEXT,
    RICH_TEXT_MODULE_TYPE_NAME_TEXT,
    SPEAKERS_MODULE_TYPE_DESCRIPTION_TEXT,
    SPEAKERS_MODULE_TYPE_NAME_TEXT,
} from '../../../../../../event-hubs.text';

export type ModuleTypeOption = {
    type: HubModuleType;
    nameText: MessageDescriptor;
    descriptionText: MessageDescriptor;
};

export const MODULE_TYPE_OPTIONS: ModuleTypeOption[] = [
    {
        type: HubModuleType.EVENTS,
        nameText: EVENTS_MODULE_TYPE_NAME_TEXT,
        descriptionText: EVENTS_MODULE_TYPE_DESCRIPTION_TEXT,
    },
    {
        type: HubModuleType.MY_EVENTS,
        nameText: MY_EVENTS_MODULE_TYPE_NAME_TEXT,
        descriptionText: MY_EVENTS_MODULE_TYPE_DESCRIPTION_TEXT,
    },
    {
        type: HubModuleType.RICH_TEXT,
        nameText: RICH_TEXT_MODULE_TYPE_NAME_TEXT,
        descriptionText: RICH_TEXT_MODULE_TYPE_DESCRIPTION_TEXT,
    },
    {
        type: HubModuleType.SPEAKERS,
        nameText: SPEAKERS_MODULE_TYPE_NAME_TEXT,
        descriptionText: SPEAKERS_MODULE_TYPE_DESCRIPTION_TEXT,
    },
];

export const POPOVER_WIDTH = 260;
export const POPOVER_GAP = 8;
